import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { ReportDetails } from "@memorang/types";
import type { GetReportRequest } from "./types";

export async function getReport(
	request: GetReportRequest,
): Promise<ReportDetails> {
	const { data } = await apiAxios.get<{ data: ReportDetails }>(
		API_ENDPOINTS.SESSION_REPORTS(request.sessionId),
	);
	return data.data;
}
